import {
    SubscriberType,
    type SubscriptionStatusCoordinator as NativeSubscriptionStatusCoordinator,
    type UserInfo,
} from '@jet-app/music-classical/dependencies/subscription-status-coordinator';
import type { Bag } from '~/jet/dependencies/bag';
import type { UserCallbacks } from '~/jet/dependencies/net';
import type { User } from '~/utils/user';

export class SubscriptionStatusCoordinator
    implements NativeSubscriptionStatusCoordinator
{
    private user: User;

    // This property has to be separate from subscriptionStatus.accountStatus because that property is used for
    // Metrics purpose and needs to accurately report back `notSubscribed` status for users who are not subscribed
    // Or Vice Versa if the users are subscribed but are in another storefront browsing content then accountStatus should be `subscribed`
    // Whereas this Flag can be actually used for UI elements like showing only Share Context Menu and not showing Add to Library button
    public isUserInHomeStorefront: boolean;

    private _getUserInfo: () => any | null = () => null;

    constructor(private readonly bag: Bag, userCallbacks: UserCallbacks) {
        this._getUserInfo = userCallbacks?.getUserInfo ?? this._getUserInfo;
    }

    get userInfo(): UserInfo {
        // This User Storefront comes from the ITUA Cookie before Media API Account Information is populated
        // It is mostly used on the server side
        const userStorefront = this._getUserInfo?.()?.storefront;
        return userStorefront
            ? {
                  storefront: this.user?.storefront || userStorefront,
                  subscriberType: this.user
                      ?.subscriberType as unknown as SubscriberType,
              }
            : null;
    }

    updateUserInfo(user: User): void {
        this.user = user;
        const userStorefront =
            this.user?.subscriptionStorefront ?? this.user?.storefront;
        this.isUserInHomeStorefront =
            userStorefront?.toLowerCase() ===
            this.bag.string('countryCode')?.toLowerCase();
    }
}
